import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs';

import {
  blazeActions,
  generalSettingsSelectors,
  RuntimeMode,
} from '@blaze-shared/app-state-data-access';

import { FormulasApiService } from './formulas-api.service';
import { fetchFormulaFunctions, setFormulaFunctions } from './formulas.actions';

@Injectable()
export class FormulasEffects {
  private readonly actions$ = inject(Actions);
  private readonly formulasApiService = inject(FormulasApiService);
  private readonly store = inject(Store);

  /**
   * The catalogue is only ever read while a formula is being written, which happens in the editor.
   * No other runtime mode pays for the request.
   */
  fetchOnEditorInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(blazeActions.initSettings),
      concatLatestFrom(() => this.store.select(generalSettingsSelectors.selectRuntimeMode)),
      filter(([, runtimeMode]) => runtimeMode === RuntimeMode.Editor),
      map(() => fetchFormulaFunctions()),
    ),
  );

  fetchFormulas$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchFormulaFunctions),
      switchMap(() => this.formulasApiService.getFunctions()),
      map((formulaFunctions) => setFormulaFunctions({ formulaFunctions })),
    ),
  );
}
